/* ============================================================
   c-visumo-collection : SNAP一覧のカテゴリタブ
   タブ押下でページ遷移せず、Visumoギャラリーの表示タグを切り替える。
   - タブ    : [role="tab"][data-tag]（すべて＝data-tag=""）
   - パネル  : [data-visumo-panel]（data-active-tag に選択タグを反映）
   - roving tabindex（選択中のみ0）＋ 左右矢印 / Home / End
   ------------------------------------------------------------
   ⚠️ 実際の絞り込み配線は hacobune 側の仕様確定後に applyFilter() を実装する。
      現状は data-active-tag の反映 ＋ タブUIの状態管理まで（実機検証用の器）。
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.c-visumo-collection').forEach((section) => {
    const tablist = section.querySelector('[role="tablist"]');
    const tabs = Array.from(section.querySelectorAll('.c-visumo-collection__tab'));
    const panel = section.querySelector('[data-visumo-panel]');
    if (!tablist || !tabs.length || !panel) return;

    /* Visumo の絞り込み反映（仕様確定後にここを実装）。
       例: data-active-tag を見て hacobune を再描画する / タグ別 collection-id に差し替える 等。 */
    const applyFilter = (tag) => {
      panel.setAttribute('data-active-tag', tag || '');
      // TODO(visumo): hacobune のタグ絞り込み手段が確定したらここで再描画する
    };

    const selectTab = (tab, moveFocus) => {
      tabs.forEach((t) => {
        const isCurrent = t === tab;
        t.classList.toggle('is-active', isCurrent);
        t.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        t.setAttribute('tabindex', isCurrent ? '0' : '-1');
      });
      applyFilter(tab.dataset.tag || '');
      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => selectTab(tab, false));
    });

    tablist.addEventListener('keydown', (e) => {
      const current = tabs.indexOf(document.activeElement);
      if (current === -1) return;
      let next = null;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = (current + 1) % tabs.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = (current - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = tabs.length - 1;
          break;
        default:
          return;
      }

      e.preventDefault();
      selectTab(tabs[next], true);
    });
  });
});
